function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from 'firebase/app';
import tasks from '@/js/tasks';
import 'firebase/auth';
import { mapMutations } from 'vuex';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import { GA_EVENTS } from '@/js/constants';

// firebase.initializeApp(firebaseConfig)
var provider = new firebase.auth.GoogleAuthProvider();

// clave de localStorage para completar el acceso por enlace al correo
var EMAIL_FOR_SIGNIN_KEY = 'inca_email_for_signin';
export default {
  data: function data() {
    return {
      // sign in buttons
      isLoading: false,
      isSignInDisabled: false,
      // form
      isFormValid: true,
      email: '',
      password: '',
      // form error
      error: false,
      errorMessages: '',
      errorProvider: false,
      errorProviderMessages: '',
      // show password field
      showPassword: false,
      // acceso por enlace al correo (passwordless)
      showEmailLink: false,
      emailLink: '',
      emailLinkSent: false,
      sendingLink: false,
      current_provider: 'google',
      providers: [{
        id: 'google',
        label: 'Sign in with Google',
        isLoading: false
      }, {
        id: 'microsoft',
        label: 'Sign in with Microsoft',
        isLoading: false
      }],
      companies: [{
        id: 'otros',
        text: 'Otras Empresas del Grupo Intercorp'
      }, {
        id: 'casa-andina',
        text: 'Casa Andina'
      }, {
        id: 'foh',
        text: 'Financiera Oh'
      }],
      companies_bk: [{
        id: 'otros',
        text: 'Otras Empresas del Grupo Intercorp'
      }, {
        id: 'casa-andina',
        text: 'Casa Andina'
      }, {
        id: 'interbank',
        text: 'Interbank'
      }, {
        id: 'intercorp',
        text: 'Intercorp'
      }],
      current_company: 'otros',
      // input rules
      rules: {
        required: function required(value) {
          return value && Boolean(value) || 'Required';
        }
      }
    };
  },
  created: function created() {
    if (process.env.VUE_APP_ENV == 'prod') {
      this.companies = [{
        id: 'otros',
        text: 'Otras Empresas del Grupo Intercorp'
      }, {
        id: 'smi',
        text: 'SMI'
      }, {
        id: 'casa-andina',
        text: 'Casa Andina'
      }, {
        id: 'foh',
        text: 'Financiera Oh'
      }, {
        id: 'interbank',
        text: 'Interbank'
      }, {
        id: 'intercorp',
        text: 'Intercorp Management'
      }];
    } else {
      this.companies = [{
        id: 'otros',
        text: 'Otras Empresas del Grupo Intercorp'
      }, {
        id: 'smi',
        text: 'SMI'
      }, {
        id: 'casa-andina',
        text: 'Casa Andina'
      }, {
        id: 'foh',
        text: 'Financiera Oh'
      }, {
        id: 'intercorp-dev',
        text: 'Intercorp Management Pruebas'
      }];
    }
    // si la URL es un enlace de acceso por correo, completar el ingreso
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      this.completeEmailLinkSignIn();
    }
    /* if (window.userInfo && window.userInfo.email) {// && window.userInfo.userRoles) {
      //console.log("go to home")
      if (window.userInfo.userRoles) {
        this.$router.push({ 'name': 'audiences' })// envConfig.defaultPathRedirect })
      } else {
        appApis.loginUser(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid).then(res => {
          userInfo.loading = false
          window.userInfo.userRoles = res.data.roles
          window.userInfo.listOrgs = res.data.list_orgs
          window.userInfo.domain = res.data.domain
          this.$store.dispatch('data-platform/getSelectFields', window.userInfo.domain, null, {root:true})
          this.$router.push({ 'name': 'audiences' })
        })
      }
    }*/
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('data-platform', ['setCompanyCode', 'setDefaultLanguage', 'setCompanyName'])), {}, {
    submit: function submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.isSignInDisabled = true;
        this.signIn(this.email, this.password);
      }
    },
    signIn: function signIn(email, password) {
      this.$router.push('/');
    },
    onLoginInterbank: function onLoginInterbank() {
      var clientId = "fadb1a8f-d210-4552-acbe-dd570244c004";
      var redirectUri = encodeURIComponent("http://localhost:8080/callback.html");
      var tenant = "e71b62e0-0608-41b7-a9ce-58d7fe8f2bf5";
      var scope = encodeURIComponent("openid profile email User.Read");
      var url = "https://login.microsoftonline.com/".concat(tenant, "/oauth2/v2.0/authorize?client_id=").concat(clientId, "&response_type=code&scope=").concat(scope, "&redirect_uri=").concat(redirectUri);
      window.location.href = url;
    },
    signInProvider: function signInProvider(provider) {},
    resetErrors: function resetErrors() {
      this.error = false;
      this.errorMessages = '';
      this.errorProvider = false;
      this.errorProviderMessages = '';
    },
    onLogin: function onLogin(providerId) {
      var _this = this;
      if (providerId === 'google') {
        provider = new firebase.auth.GoogleAuthProvider();
      } else if (providerId === 'microsoft') {
        provider = new firebase.auth.OAuthProvider('microsoft.com');
      } else if (providerId.indexOf("saml.") != -1) {
        provider = new firebase.auth.SAMLAuthProvider(providerId);
      } else if (providerId === 'github') {
        provider = new firebase.auth.GithubAuthProvider();
      }
      firebase.auth().signInWithPopup(provider).then(function () {
        _this.handleAuthenticatedUser();
      });
    },
    // Envía el enlace de acceso sin contraseña al correo indicado.
    // Lo genera y envía el backend (Admin SDK + correo corporativo) para que
    // pase los filtros de los tenants Microsoft; si el endpoint aún no está
    // disponible, cae al envío directo de Firebase.
    sendEmailLink: function sendEmailLink() {
      var _this2 = this;
      var email = (this.emailLink || '').trim().toLowerCase();
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(email)) {
        tasks.toast.warning('Ingresa un correo válido.');
        return;
      }
      this.emailLink = email;
      this.sendingLink = true;
      // El router corre en modo hash: la URL de retorno debe apuntar al
      // fragmento (#/ContLogin); una ruta de path daría 404 en Hosting.
      var continueUrl = window.location.origin + '/#/ContLogin';
      UserSecurityService.sendEmailLink({
        email: email,
        continue_url: continueUrl
      }).then(function (res) {
        _this2.sendingLink = false;
        if (res && res.success) {
          window.localStorage.setItem(EMAIL_FOR_SIGNIN_KEY, email);
          _this2.emailLinkSent = true;
        } else {
          tasks.toast.error(res && res.message || 'No se pudo enviar el enlace. Intenta nuevamente.');
        }
      }).catch(function (e) {
        console.warn('email_link/send no disponible, usando envío directo de Firebase', e);
        _this2.sendEmailLinkWithFirebase(email, continueUrl);
      });
    },
    sendEmailLinkWithFirebase: function sendEmailLinkWithFirebase(email, continueUrl) {
      var _this3 = this;
      firebase.auth().sendSignInLinkToEmail(email, {
        url: continueUrl,
        handleCodeInApp: true
      }).then(function () {
        window.localStorage.setItem(EMAIL_FOR_SIGNIN_KEY, email);
        _this3.emailLinkSent = true;
        _this3.sendingLink = false;
      }).catch(function (e) {
        _this3.sendingLink = false;
        console.error(e);
        if (e.code === 'auth/operation-not-allowed') {
          tasks.toast.error('El acceso por enlace no está habilitado. Contacta al administrador.');
        } else if (e.code === 'auth/unauthorized-continue-uri') {
          tasks.toast.error('El dominio de la aplicación no está autorizado para el enlace de acceso.');
        } else {
          tasks.toast.error('No se pudo enviar el enlace. Intenta nuevamente.');
        }
      });
    },
    // Completa el ingreso cuando el usuario vuelve desde el enlace del correo
    completeEmailLinkSignIn: function completeEmailLinkSignIn() {
      var _this4 = this;
      var link = window.location.href;
      // Limpia los parámetros del enlace (oobCode, mode, apiKey) de la barra de
      // direcciones: quedan en location.search y la navegación del SPA no los
      // borra, por lo que un logout o recarga volvería a disparar este flujo.
      window.history.replaceState(null, '', window.location.pathname + window.location.hash);
      var email = window.localStorage.getItem(EMAIL_FOR_SIGNIN_KEY);
      if (!email) {
        // abrió el enlace en otro dispositivo/navegador: confirmar identidad
        email = window.prompt('Confirma tu correo para completar el ingreso:');
      }
      if (!email) return;
      firebase.auth().signInWithEmailLink(email.trim().toLowerCase(), link).then(function () {
        window.localStorage.removeItem(EMAIL_FOR_SIGNIN_KEY);
        _this4.handleAuthenticatedUser();
      }).catch(function (e) {
        console.error(e);
        if (e.code === 'auth/invalid-action-code') {
          tasks.toast.error('El enlace ya fue usado o expiró. Solicita uno nuevo.');
        } else if (e.code === 'auth/invalid-email') {
          tasks.toast.error('El correo no coincide con el enlace recibido.');
        } else {
          tasks.toast.error('No se pudo completar el ingreso con el enlace.');
        }
      });
    },
    // Completa la sesión INCA (roles, orgs, stores) para cualquier proveedor:
    // popup (Google/Microsoft/SAML) o enlace al correo. El backend (loginUser)
    // sigue siendo quien autoriza al usuario, sin importar el proveedor.
    handleAuthenticatedUser: function handleAuthenticatedUser() {
      var _this5 = this;
      var service = UserSecurityService;
      var userLogin = firebase.auth().currentUser;
      var userInfo = window.userInfo || {};
      // user info is global var
      window.userInfo = window.userInfo || {};
      userInfo['email'] = userLogin.email ? userLogin.email.toLowerCase() : userLogin.email;
      userInfo['displayName'] = userLogin.displayName;
      userInfo['userLogin'] = userLogin;
      userInfo['accessToken'] = userLogin.xa || userLogin._lat || userLogin.ma;
      userInfo['localId'] = userLogin.uid;
      userInfo['photoURL'] = userLogin.photoURL;
      userInfo['loading'] = window.userInfo.loading;
      userInfo['userRoles'] = window.userInfo.userRoles || null;
      userInfo['listOrgs'] = window.userInfo.listOrgs || null;
      // send login on secondbackground
      var user = {
        email: userLogin.email ? userLogin.email.toLowerCase() : userLogin.email,
        uid: userLogin.uid,
        displayName: userLogin.displayName,
        emailVerified: userLogin.emailVerified,
        phoneNumber: userLogin.phoneNumber,
        photoURL: userLogin.photoURL,
        created: userLogin.metadata.creationTime,
        lastSignIn: userLogin.metadata.lastSignInTime
      };
      //console.log(user)
      window.userInfo.isSignIn = true;
      window.userInfo.loading = true;
      tasks.lockScreen.lock();
      service.loginUser(userInfo.email, userInfo.accessToken, userInfo.uid, user).then(function (res) {
        tasks.lockScreen.unlock();
        _this5.$store.dispatch('analytic-services/setFlags', res.data.flags);
        _this5.$store.dispatch('data-platform/setFlags', res.data.flags);
        var is_ad = res.data.is_ad;
        var type = 'google';
        if (is_ad && is_ad == "AZURE") {
          type = 'azure';
          /*userLogin.providerData.forEach((profile) => {
            if (profile.providerId == 'google.com') {
              window.alert("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Office 365.")
              //tasks.toast.error("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Microsoft.")
              tasks.logoutApplication()
            }
          })*/
          userLogin.getIdTokenResult().then(function (idTokenResult) {
            var signInProvider = idTokenResult.signInProvider; // <-- ESTE ES EL DATO REAL
            console.log("Logueado actualmente con:", signInProvider);
            if (signInProvider == 'google.com') {
              window.alert("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Office 365.");
              //tasks.toast.error("El usuario no está autorizado para ingresar con Google. Por favor, utilice su cuenta corporativa de Microsoft.")
              tasks.logoutApplication();
            }
          });
        }
        if (_this5.$gtm.enabled() && window.dataLayer) {
          window.dataLayer.push({
            event: GA_EVENTS.LOGIN,
            eventName: GA_EVENTS.LOGIN,
            domain: res.data.domain,
            hash_email: _this5.stringToHash(userInfo.email),
            type: type
            // further parameters
          });
        }
        userInfo.loading = false;
        window.userInfo.userRoles = res.data.roles;
        window.userInfo.listOrgs = res.data.list_orgs;
        window.userInfo.domain = res.data.domain;
        window.userInfo.base_url = res.data.inca_base_url;
        _this5.userInfo = window.userInfo;
        //this.$store.dispatch('data-platform/getLoginDetail')
        UserSecurityService.loginDetail(window.userInfo.email, window.userInfo.accessToken, window.userInfo.uid, user).then(function (res2) {
          window.userInfo.listOrgs = res2.data.list_orgs;
          window.userInfo.orgs = res2.data.orgs;
          window.userInfo.photoURL = userLogin.photoURL;
          window.userInfo.base_url = res2.data.inca_base_url;
          window.userInfo.somos1_agreement = res2.data.somos1_agreement;
          _this5.$store.commit('data-platform/setBaseUrl', res2.data.inca_base_url);
          _this5.$store.commit('data-platform/setDefaultLanguage', res2.data.defaultLanguage);
          _this5.$store.commit('data-platform/setCompanyCode', res2.data.companyCode);
          _this5.$store.commit('data-platform/setCompanyName', res2.data.companyName);
          _this5.$store.commit('data-platform/setOrgs', res2.data.orgs);
          _this5.$store.commit('data-platform/setMessagingToken', res2.data.messagingToken);
          _this5.$store.commit('data-platform/setDomainsOptional', res2.data.domains_optional);
          _this5.setLocale(res2.data.defaultLanguage);
        });
        _this5.$store.dispatch('data-platform/getSelectFields', window.userInfo.domain, null, {
          root: true
        });
        _this5.$store.dispatch('data-platform/hideInitialSetupMenu', null, {
          root: true
        });
        _this5.$store.dispatch('data-platform/getIsTableauActive', null, {
          root: true
        });
        _this5.$store.dispatch('data-platform/getSynapseStatus', window.userInfo.domain, {
          root: true
        });
        _this5.$store.dispatch('data-platform/getBigqueryStatus', window.userInfo.domain, {
          root: true
        });
        //this.$store.dispatch('data-platform/getCompanyCode', null, { root: true })
        _this5.$store.dispatch('data-platform/getUserNotifications', userLogin.email, {
          root: true
        });
        //this.$store.commit('data-platform/setDefaultLanguage', res.data.defaultLanguage)
        //this.$store.commit('data-platform/setOrgs', res.data.orgs)
        //this.$store.commit('data-platform/setMessagingToken', res.data.messagingToken)
        //this.setCompanyCode(res.data.companyCode)
        //this.setCompanyName(res.data.companyName)
        //this.setDefaultLanguage(res.data.defaultLanguage)
        //this.setLocale(res.data.defaultLanguage)
        _this5.$store.dispatch('attribute/getCompanyAbrevs');
        _this5.$store.dispatch('attribute/getLabelCatalog');
        _this5.$store.dispatch('attribute/getStatusLogTypes');
        _this5.$store.dispatch('attribute/getAttributeSourcesCatalog');
        _this5.$store.dispatch('customer-insights/getInitialData');
        _this5.$store.dispatch('audience/getCompanyFlags');
        _this5.$store.dispatch('attribute/getCompanyFlags', res.data.companyCode);
        _this5.$store.dispatch('attribute/getBusinessUserServiceAccounts', res.data.companyCode);
        //console.log('go home')
        _this5.$router.replace({
          name: 'HomePage'
        });
      });
    }
  })
};